import React, { memo } from 'react';

import WithWizard from 'modules/views/shared/Wizard/WithWizard';

import { ConsentFormProvider, useConsentFormContext } from './context/ConsentFormContext';
import { ProjectInformationPage, ConsentFormPage, CustomConsentFormStep } from './components';

const ConsentFormContent = () => {
  const { step, isLoading } = useConsentFormContext();

  const steps = () => {
    switch (step) {
      case 0:
        return <ProjectInformationPage />;
      case 1:
        return <ConsentFormPage />;
      case 2:
        return <CustomConsentFormStep />;
      default:
        return null;
    }
  };

  const content = <div>{steps()}</div>;

  return <WithWizard content={content} disableNavigation={isLoading} />;
};

const ConsentForm = () => {
  return (
    <ConsentFormProvider>
      <ConsentFormContent />
    </ConsentFormProvider>
  );
};

export default memo(ConsentForm);
